import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {BannerAction} from '../../../../../../libs/shared/ui/src/components/banners/bannerAction';
import {fontSizes} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface StaticViewerBannerActionProps {
  onClick: () => void;
  className?: string;
  isDisabled?: boolean;
}

/*
 * Style.
 */

const StyledBannerAction = styled(BannerAction)`
  display: inline-block;
  margin-bottom: -9px;
  font-size: ${fontSizes.tiny};
`;

/*
 * Component.
 */

export const StaticViewerBannerAction: FC<PropsWithChildren<StaticViewerBannerActionProps>> = (props) => (
  <StyledBannerAction className={props.className} isDisabled={props.isDisabled} onClick={props.onClick}>
    {props.children}
  </StyledBannerAction>
);
